/**
 * Serviço do **Resumo Diário** — turno × grupo × valor (ocorrências).
 *
 * Demo: `buildDemoDailySummary.js`.
 * Produção: `ClassDiaryV1/daily-summary/*` → SOCORRENCIAALUNO + `#DS:{periodo}`.
 */

import { api } from "../utils/api";
import UserStore from "../utils/UserStore";
import isClassDiaryDemo from "../demo/isClassDiaryDemo";
import {
  buildDemoDSConcepts,
  buildDemoDSDateOptions,
  buildDemoDSList,
  buildDemoDSPeriods,
  buildDemoDSReportData
} from "../demo/buildDemoDailySummary";

function appendSemConceito(concepts) {
  const list = Array.isArray(concepts) ? [...concepts] : [];
  list.push({ label: "Sem conceito", color: "#FFFFFF" });
  return list;
}

const getMoments = async () => {
  if (isClassDiaryDemo()) return buildDemoDSPeriods();
  const res = await api.get("ClassDiaryV1/daily-summary/moments");
  return Array.isArray(res.data) ? res.data : [];
};

const getDateOptions = async () => {
  if (isClassDiaryDemo()) return buildDemoDSDateOptions();
  const res = await api.get("ClassDiaryV1/daily-summary/dates");
  return Array.isArray(res.data) ? res.data : [];
};

const getConcepts = async () => {
  if (isClassDiaryDemo()) return appendSemConceito(buildDemoDSConcepts());
  const res = await api.get("ClassDiaryV1/daily-summary/concepts");
  return appendSemConceito(Array.isArray(res.data) ? res.data : []);
};

const getReportData = async (classId, date, momentId) => {
  if (isClassDiaryDemo()) return buildDemoDSReportData(date, momentId);
  const res = await api.get("ClassDiaryV1/daily-summary", {
    params: { classId, date, momentId }
  });
  if (
    res.data &&
    typeof res.data === "object" &&
    Array.isArray(res.data.students) &&
    Array.isArray(res.data.axis)
  ) {
    return res.data;
  }
  return { axis: [], students: [] };
};

const listSummaries = async classId => {
  if (isClassDiaryDemo()) return buildDemoDSList(classId);
  const res = await api.get("ClassDiaryV1/daily-summary/list", {
    params: { classId }
  });
  return Array.isArray(res.data) ? res.data : [];
};

/**
 * @param {{
 *   classId: string,
 *   date: string,
 *   momentId: string,
 *   idTurmaDisc?: string,
 *   cells: Array<object>,
 *   cleared: Array<object>
 * }} data
 */
const save = async data => {
  if (isClassDiaryDemo()) return { success: true };
  const res = await api.post("ClassDiaryV1/daily-summary", {
    ...data,
    externalData: UserStore.getUserExternalInfo()
  });
  return res.data;
};

export default {
  getMoments,
  getDateOptions,
  getConcepts,
  getReportData,
  listSummaries,
  save
};
